import axios from 'axios'

class ActionService {
  constructor() {
    this.baseUrl = '/api/v1/survey'
  }

  saveAction(data) {
    return axios.put(`${this.baseUrl}/save_health_action/`, data)
  }
}

export const actionService = new ActionService()
